import { render } from "./tooltips.vue?vue&type=template&id=1aa22dfd&scoped=true"
import script from "./tooltips.vue?vue&type=script&lang=js"
export * from "./tooltips.vue?vue&type=script&lang=js"

import "./tooltips.vue?vue&type=style&index=0&id=1aa22dfd&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-new-front.rule.vip.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa22dfd"]])

export default __exports__